var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurious(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2136_65143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 22.4983C19 22.4983 22.4983 17.7977 22.4983 11.9992C22.4983 6.20064 19 1.5 11.9992 1.5C4.99833 1.5 1.5 6.20064 1.5 11.9992C1.5 17.7977 4.99833 22.4983 11.9992 22.4983Z",
    fill: "url(#paint0_radial_2136_65143)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 22.4983C19 22.4983 22.4983 17.7977 22.4983 11.9992C22.4983 6.20064 19 1.5 11.9992 1.5C4.99833 1.5 1.5 6.20064 1.5 11.9992C1.5 17.7977 4.99833 22.4983 11.9992 22.4983Z",
    fill: "url(#paint1_radial_2136_65143)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 22.4983C19 22.4983 22.4983 17.7977 22.4983 11.9992C22.4983 6.20064 19 1.5 11.9992 1.5C4.99833 1.5 1.5 6.20064 1.5 11.9992C1.5 17.7977 4.99833 22.4983 11.9992 22.4983Z",
    fill: "url(#paint2_radial_2136_65143)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 22.4983C19 22.4983 22.4983 17.7977 22.4983 11.9992C22.4983 6.20064 19 1.5 11.9992 1.5C4.99833 1.5 1.5 6.20064 1.5 11.9992C1.5 17.7977 4.99833 22.4983 11.9992 22.4983Z",
    fill: "url(#paint3_radial_2136_65143)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 22.4983C19 22.4983 22.4983 17.7977 22.4983 11.9992C22.4983 6.20064 19 1.5 11.9992 1.5C4.99833 1.5 1.5 6.20064 1.5 11.9992C1.5 17.7977 4.99833 22.4983 11.9992 22.4983Z",
    fill: "url(#paint4_radial_2136_65143)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 22.4983C19 22.4983 22.4983 17.7977 22.4983 11.9992C22.4983 6.20064 19 1.5 11.9992 1.5C4.99833 1.5 1.5 6.20064 1.5 11.9992C1.5 17.7977 4.99833 22.4983 11.9992 22.4983Z",
    fill: "url(#paint5_radial_2136_65143)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 22.4983C19 22.4983 22.4983 17.7977 22.4983 11.9992C22.4983 6.20064 19 1.5 11.9992 1.5C4.99833 1.5 1.5 6.20064 1.5 11.9992C1.5 17.7977 4.99833 22.4983 11.9992 22.4983Z",
    fill: "url(#paint6_radial_2136_65143)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 22.4983C19 22.4983 22.4983 17.7977 22.4983 11.9992C22.4983 6.20064 19 1.5 11.9992 1.5C4.99833 1.5 1.5 6.20064 1.5 11.9992C1.5 17.7977 4.99833 22.4983 11.9992 22.4983Z",
    fill: "url(#paint7_radial_2136_65143)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.75,
    cy: 9.75,
    r: 3.75,
    fill: "url(#paint8_radial_2136_65143)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.625,
    cy: 10.125,
    r: 3.375,
    fill: "url(#paint9_radial_2136_65143)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.875 12C9.73896 12 11.25 10.489 11.25 8.625C11.25 6.76104 9.73896 5.25 7.875 5.25C6.01104 5.25 4.5 6.76104 4.5 8.625C4.5 10.489 6.01104 12 7.875 12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.125 12C17.989 12 19.5 10.489 19.5 8.625C19.5 6.76104 17.989 5.25 16.125 5.25C14.261 5.25 12.75 6.76104 12.75 8.625C12.75 10.489 14.261 12 16.125 12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 10.5C9.82843 10.5 10.5 9.82843 10.5 9C10.5 8.17157 9.82843 7.5 9 7.5C8.17157 7.5 7.5 8.17157 7.5 9C7.5 9.82843 8.17157 10.5 9 10.5Z",
    fill: "url(#paint10_linear_2136_65143)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10.5C15.8284 10.5 16.5 9.82843 16.5 9C16.5 8.17157 15.8284 7.5 15 7.5C14.1716 7.5 13.5 8.17157 13.5 9C13.5 9.82843 14.1716 10.5 15 10.5Z",
    fill: "url(#paint11_linear_2136_65143)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 13.5,
    width: 6,
    height: 7.5,
    rx: 3,
    fill: "url(#paint12_radial_2136_65143)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2136_65143",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.125 6.75) rotate(132.839) scale(28.1275)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474827,
    stopColor: "#FFB02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F70A8D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2136_65143",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.125 6.75) rotate(131.878) scale(29.2115)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474827,
    stopColor: "#FFB02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F70A8D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2136_65143",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12 9.375) rotate(101.31) scale(13.3849 17.1435)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.787821,
    stopColor: "#F59639",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972509,
    stopColor: "#FF7DCE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2136_65143",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5 10.5) rotate(135) scale(30.7591)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.314853,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2136_65143",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12 12.75) rotate(77.692) scale(21.1102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.507903,
    stopColor: "#7D6133",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#715B32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2136_65143",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.375 12.375) rotate(55.7131) scale(9.98515 7.23774)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB847",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2136_65143",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.375 13.5) rotate(9.86581) scale(8.75446)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA64B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.900412,
    stopColor: "#FFAE46",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2136_65143",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.125 11.25) rotate(43.9708) scale(44.2897)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.185425,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2136_65143",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.66667 6.83333) rotate(135) scale(7.30677 3.78174)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#392108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C87928",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2136_65143",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.25 7.5) rotate(135) scale(6.0988 3.44287)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#392108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C87928",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2136_65143",
    x1: 15.4615,
    y1: 7.5,
    x2: 14.9449,
    y2: 10.5226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#553B3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D2432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2136_65143",
    x1: 15.4615,
    y1: 7.5,
    x2: 14.9449,
    y2: 10.5226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#553B3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D2432"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_2136_65143",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12 22.6667) rotate(-90) scale(9.16667 7.33333)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F70A8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89029C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2136_65143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurious);
export default __webpack_public_path__ + "static/media/curious.d8aa5b0f.svg";
export { ForwardRef as ReactComponent };